import React, { useMemo } from 'react';
import { createStyles } from '@/contexts/theme-context';
import { OrderValidation } from '@/experiences/sales-portal/domain/ordering/blocs/mutators/use-save-sales-portal-cart-mutator';
import { ValidationBanner } from '@/experiences/sales-portal/components/validation-banner';
import { View } from 'react-native';

interface OrderSummaryAlertsProps {
  orderValidation: OrderValidation | null;
}

export const OrderSummaryAlerts: React.FC<OrderSummaryAlertsProps> = ({
  orderValidation,
}) => {
  const [styles] = useStyles();

  const orderValidationAlerts = useMemo(
    () => orderValidation?.alerts ?? [],
    [orderValidation],
  );

  if (orderValidationAlerts.length === 0) {
    return null;
  }

  return (
    <View style={styles.orderSummaryAlerts}>
      {orderValidationAlerts.map((alert) => (
        <ValidationBanner
          key={`${alert.level}-${alert.message}`}
          level={alert.level}
          message={alert.message}
        />
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  orderSummaryAlerts: {
    flexDirection: 'column',
    gap: theme.sk.spacing.spaceSmall,
  },
}));
